import React, { useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { useNavigate, useParams } from "react-router-dom";
import url from "../../config.js";
import intelogicon from "../../assets/icons/intelog_new_png.png";
import "../login/login.scss";

const domain = url.domain;

function ResetPassword() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${domain}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (data.success) {
        setDone(true);
      } else {
        setError(data.message || "Reset link is invalid or has expired.");
      }
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const eyeIcon = showPassword ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );

  return (
    <div className="login-root">
      <CssBaseline />
      <div className="login-split-container">

        {/* Left — branding */}
        <div className="login-left-side">
          <div className="branding-content">
            <div className="logo-wrapper">
              <img src={intelogicon} alt="INTELOG" className="brand-logo" />
            </div>
            <div className="quote-section">
              <h1 className="brand-headline">Choose a new password</h1>
              <p className="brand-description">
                Pick something strong — at least 8 characters.
              </p>
            </div>
          </div>
        </div>

        {/* Right — form */}
        <div className="login-right-side">
          <div className="form-wrapper">
            {done ? (
              <div className="success-container">
                <div className="success-icon-container">
                  <div className="success-icon-circle">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  </div>
                </div>
                <div className="success-message-box">
                  <h2 className="success-message-title">Password updated</h2>
                  <p className="success-message-text">
                    Your password has been changed successfully. You can now log in with your new password.
                  </p>
                </div>
                <button type="button" className="form-button" onClick={() => navigate("/")}>
                  Go to Login
                </button>
              </div>
            ) : (
              <div className="form-container">
                <div className="form-header">
                  <h2 className="form-title">Set New Password</h2>
                  <p className="form-subtitle">Enter and confirm your new password below.</p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-label">New Password</label>
                    <TextField
                      className="form-input"
                      variant="outlined"
                      fullWidth
                      type={showPassword ? "text" : "password"}
                      placeholder="At least 8 characters"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoFocus
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(v => !v)}
                              edge="end"
                              style={{ color: '#6b849a' }}
                            >
                              {eyeIcon}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Confirm Password</label>
                    <TextField
                      className="form-input"
                      variant="outlined"
                      fullWidth
                      type={showPassword ? "text" : "password"}
                      placeholder="Repeat your new password"
                      value={confirm}
                      onChange={(e) => setConfirm(e.target.value)}
                    />
                  </div>

                  {error && <div className="error-message">{error}</div>}

                  <button
                    type="submit"
                    className="form-button"
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update Password"}
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

export default ResetPassword;
